import React, { Component } from 'react';
import { socketConnect } from 'socket.io-react';
import PropTypes from 'prop-types';
import Modal from 'components/Modal';
import InputValidation from 'components/InputValidation';
import { browserHistory,Link } from 'react-router';
import LogoImage from 'assets/Basiligo-Logo.png';
import LeftArrow from 'assets/btn-left-arrow.png';
import AndroidImage from 'assets/andriod-app.png';
import AppleImage from 'assets/apple-app.png';
class Restore extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      errors: {},
      showModal: false,
      modalMessage: '',
      xyz: false
    };
  }

  listener = action => {
    if (this.RestoreRef) {
      if (action.type === 'tryOk') {
        this.setState({
          showModal: true,
          modalMessage: (
            <div>
              <h3>Email sent!</h3>
              <p>{action.message}</p>
              <p> In case of any difficulties please reach us on <a href="tel:+971025530049" class="tel">02-553-0049</a> or <a href="tel:+9710507218261" class="tel">050-721-8261</a></p>
            </div>
          )
        });
      } else if (action.type === 'tryErr') {
        console.log('restore error');
        this.setState({ errors: action.errors });
      }
    }
  };

  componentWillMount() {
    this.props.socket.on('restore_password', this.listener);
  }

  componentWillUnmount() {
    this.props.socket.removeListener('restore_password', this.listener);
  }

  componentDidMount() {
    setTimeout(() => this.setState({ xyz: true }), 10);
  }

  submit(e) {
    e.preventDefault();
    const data = {
      email: this.state.email
    };
    this.props.socket.emit('restore_password', { type: 'try', data: data });
  }

  render() {
    const { errors, showModal, modalMessage, xyz } = this.state;
    const onChange = (name, value) => this.setState({ [name]: value });
    return (
      <div ref={el => (this.RestoreRef = el)} >
        <div className='sign-container'>
        <div className='sign-b-left'>            
        <div className='sign-up-form restore-form'>
          <div className='logo mb-4'>  <Link to='/' onClick={() => stop()} onlyActiveOnIndex><img className='img-logo' src={LogoImage} alt='Basiligo' /></Link></div>
          <p> Trouple with logging in?</p>
          <div className='search-title mt-1'>
            <span className='colorTitle'>Enter your registered email address and we'll send you a link to get back into your account</span>
          </div>
          <form className='form' onSubmit={e => this.submit(e)}> 
            <div className='sign-up-input mt-4'>
              <InputValidation
                name='email'
                value={this.state.email}
                onChange={onChange}
                placeholder={'E-mail address'}
                className={`form-input ${'email' in errors ? 'has-error' : ''}`}
                errors={errors}
                inputSelfClassName='standart-input b-rounded-blue'
              />
            </div>
            <div className='sign-up-input my-4 sign-up-button d-flex align-items-center justify-content-around'>
              <input type='submit' value='Send Login Link' className='letter-sm w-100' />
            </div>
            <div className='mt-4 mr-1 text-center'>
               <span className='login-text'><img src={LeftArrow} alt='Back' /> <Link to='/sign-in'>Back</Link></span>
            </div>
          </form>
        </div>
        {showModal &&
          <Modal
            close={() => {
              this.setState({ showModal: false });
              browserHistory.push('/sign-in');
            }}
            message={modalMessage}
            headLine="Password Reset"
          />
        }
        </div>
         <div className={`sign-b-right`}>
                    <div className='sign-b-right-details'><h2>Plan First, Eat Smart</h2>
                    <h6>Explore your menu, select your dishes, and discover new healthy favorites —<br/><strong>all before you subcribe.</strong></h6>
                    <ul className='login-list'>
                      <li>Preview every meal</li>
                      <li>Personalize your plan</li>
                      <li>Full ingredient transparency</li>
                    </ul>
                    <div className='app-store-gpay'>
                        <Link to='https://apps.apple.com/bg/app/basiligo-meal-plan/id6496685190' ><img className='img-play' src={AppleImage} alt='Basiligo Apple Store' /></Link>
                      <Link to='https://play.google.com/store/apps/details?id=com.basiligo.basiligomobileapp' ><img className='img-app' src={AndroidImage} alt='Google Play Store' /></Link>
                    </div>
                    <h6 className='applink-head'>Download the Basiligo App to Get Started</h6>
                    </div>
              </div>
      </div>
      </div>
    );
  }
}

Restore.propTypes = {
  socket: PropTypes.object.isRequired
};

export default socketConnect(Restore);